import { useFeatures, type WorkspaceFeatures } from "@expert/features";

import { usePartnerConfig } from "@/partner/usePartnerConfig";

export function useIsPacingActive(): boolean {
    const {
        features: { isPacingEnabled },
    } = useFeatures<WorkspaceFeatures>();
    const { pacingTargets } = usePartnerConfig();
    return Boolean(isPacingEnabled) && Boolean(pacingTargets?.enabled);
}
